import React from 'react';

export function VerticalLine() {
  return <div className="absolute bottom-0 left-1/2 h-[calc(100%-42px)] w-1 -translate-x-1/2 bg-cornflower-500/50" />;
}
